import React from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { SmoothScroll } from "./components/SmoothScroll";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { FeaturedVisuals } from "./components/FeaturedVisuals";
import { About } from "./components/About";
import { Manifesto } from "./components/Manifesto";
import { Music } from "./components/Music";
import { Merch } from "./components/Merch";
import { Booking } from "./components/Booking";
import { Community } from "./components/Community";
import { Footer } from "./components/Footer";

function App() {
  return (
    <SmoothScroll>
      <div className="App relative">
        <Navbar />
        <main>
          <Hero />
          <Marquee
            speed={70}
            items={[
              "IT'S MALIE",
              "SOUND THAT MOVES CULTURE",
              "FAITH · FREEDOM · LEGACY",
              "HEAD IN THE SKY — OUT NOW",
            ]}
          />
          <FeaturedVisuals />
          <About />
          <Manifesto />
          <Marquee
            speed={80}
            variant="outline"
            items={[
              "PATERSON → NORFOLK",
              "THE COMMUNITY",
              "THE MOVEMENT",
              "IT'S MALIE",
            ]}
          />
          <Music />
          <Merch />
          <Booking />
          <Community />
        </main>
        <Footer />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "rgba(10,10,10,0.92)",
              border: "1px solid rgba(212,175,55,0.25)",
              color: "#f5f5f5",
              backdropFilter: "blur(20px)",
            },
          }}
        />
      </div>
    </SmoothScroll>
  );
}

export default App;
